import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import FieldsetSubHeader from "../common/FieldsetSubHeader";

const RadioButtonGroup = (props) => {
	const { optionGroupKey } = props;

	const TOOLTIP_LOCKED_TEXT = "Je antwoord is geblokkeerd omdat er reeds bestanden aan de vraag gekoppeld zijn. Indien je alsnog je antwoord wil veranderen moet je eerst alle documenten handmatig verwijderen.";
	const lockedText = props.lockedText ? props.lockedText : TOOLTIP_LOCKED_TEXT;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const labelInsideControl = props.labelInside;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = (props.label ? props.label : "") + (props.optional ? " (Optioneel)" : "");
	const value = props.value == null ? 'null' : props.value == true ? 'true' : (props.value == false && props.value != "0") ? 'false' : props.value;
	const disabled = props.disabled || props.readonly || props.locked;
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} isInput={labelInsideControl} windowWidth={props.tooltipWindowWidth} windowAlignRight={props.tooltipWindowAlignRight} /> : null;
	const locked = props.locked ? <Tooltip text={lockedText} icon={types.TOOLTIP_ICON_LOCK} isLocked tooltipType={types.TOOLTIP_INFO} isInput isSecundaryTooltip /> : null;
	const validation = props.validationMessage ? <ValidationMessage validationMessage={props.validationMessage} type={validationMessageType} /> : null;
	const onChange = disabled ? null : props.onChange;
	const isHighlighted = props.isHighlighted;
	const radioClassName = {
		"c-input": true,
		"radiobuttonlist": true,
		"disabled": disabled,
		"inline": props.horizontal,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING
	};

	const isDisabled = (i) => {
		if (props.disabled || props.readonly || props.locked) return true;
		if (props.itemsLocked && props.itemsLocked[i]) {
			return props.itemsLocked[i].locked;
		}
		else return false;
	};

	const options = props.items.map((item, i) =>
		(<div key={props.name + i + (optionGroupKey ? optionGroupKey : "")} className="c-input__group">
			<input type="radio" name={props.name} onChange={onChange} value={item.value}
				checked={item.value.toString() === value.toString()} id={props.name + i + (optionGroupKey ? optionGroupKey : "")} disabled={isDisabled(i)} />
			<label htmlFor={props.name + i + (optionGroupKey ? optionGroupKey : "")} style={{ display: 'inline-block' }}>{item.label}</label>
			{props.itemsLocked && props.itemsLocked[i] && props.itemsLocked[i].locked ?
				<Tooltip windowWidth={25} text={props.itemsLocked[i].text} icon={types.TOOLTIP_ICON_LOCK} iconColor={'grey'} optionTooltip />
				: null}
		</div>));

	const component = (
		<div value={props.value} className={classnames(sizeClassName)}>
			<div className={classnames(radioClassName)}>
				{labelInsideControl ? <div className="c-input__label has-value">{label}</div> : ""}
				<div className="c-input__field">{options}</div>
				{labelInsideControl ? info : ""}{locked}
			</div>
			{validation}
		</div>);

	return (labelInsideControl
		?
		component
		:
		<div>
			{label || info ? <FieldsetSubHeader>{label} {info}</FieldsetSubHeader> : null}
			{component}
		</div>

	);
};

RadioButtonGroup.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	items: PropTypes.array.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string,
		PropTypes.number
	]),
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	horizontal: PropTypes.bool,
	size: PropTypes.number,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readonly: PropTypes.bool,
	optional: PropTypes.bool,
	labelInside: PropTypes.bool,
	locked: PropTypes.bool,
	lockedText: PropTypes.string,
	isHighlighted: PropTypes.bool,
	optionGroupKey: PropTypes.string,
	itemsLocked: PropTypes.array
};

export default RadioButtonGroup;
